// test2623
(2623 && 0);
